import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';

import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';

import { Twig } from '../../types';
import Text from '../../components/Text';
import Paper from '../../components/Paper';
import Grid from '../../components/Grid';
import { history } from '../../config/store';
import BackgroundImage from '../../components/BackgroundImage';

export interface TrendsProps {
  trends: Twig[];
}

const Trends: React.FC<TrendsProps> = ({ trends }) => {
  const classes = useStyles();

  const renderTwig = (twig: Twig) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const handleClick = useCallback(() => {
      history.push(`/${twig.uniqueName}`);
    }, [twig]);

    return (
      <div className={classes.trend} onClick={handleClick}>
        <div className={classes.trendImgContainer}>
          <BackgroundImage
            src={twig.mediaThumbUrl}
            resizeMode="cover"
            height="100%"
          />
        </div>
        <div className={classes.trendOverlay}>
          <div className={classes.avatarBox}>
            <Image
              className={classes.avatar}
              src={twig.user.avatarUrl}
              alt={twig.user.name}
              roundedCircle
            />
          </div>
          <Text className={classes.trendTitle} as="p" color="white" bold>
            {/* {`${twig.user.username.slice(0, 20)}${twig.user.username.length > 20 ? '...' : ''
              }`} */}

            {twig.user.username ?
              twig.user.username.slice(0, 20)
              : null}
            {twig.user.username && twig.user.username.length > 20 ? '...' : ''}
          </Text>
        </div>
      </div>
    );
  };

  const keyExtractor = (twig: Twig) => twig.id;

  return (
    <Container>
      <Paper className="p-3" withShadow={false}>
        <Text as="h4" align="center" capitalized>
          Trends for you
        </Text>
        <Grid
          className="mt-5"
          colClassName={classes.trendColumn}
          data={trends}
          renderItem={renderTwig}
          keyExtractor={keyExtractor}
          itemsPerRow={{
            xs: 1,
            lg: 2,
          }}
          fluid
        />
      </Paper>
    </Container>
  );
};

const useStyles = createUseStyles({
  trendColumn: {
    paddingLeft: '5px',
    paddingRight: '5px',
  },
  trend: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: '10px',
    overflow: 'hidden',
    minHeight: '250px',
    boxShadow: '1px 1px 4px #EEEEEE',
    cursor: 'pointer',
  },
  trendImgContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  trendImg: {
    width: '100%',
    height: '100%',
  },
  trendOverlay: {
    position: 'absolute',
    bottom: "10px",
    left: 0,
    right: 0,
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  avatarBox: {
    width: '40px',
    height: '40px',
    overflow: 'hidden',
  },
  avatar: {
    width: '100%',
    height: '100%',
  },
  trendTitle: {
    textShadow: '2px 2px 2px #666666',
    fontSize: '0.7rem',
    textAlign: 'center',
  },
  link: {
    color: '#FFFFFF',
    '&:hover': {
      color: '#FFFFFF',
    },
  },
});

export default Trends;
